// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-o_gg","galleryThumbnail_active":"c-o_gh","galleryThumbnail__image":"c-o_gi"};